import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/translation.en.json';
import svTranslation from './locales/translation.sv.json';

i18next
  .use(initReactI18next)
  .init({
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language if translation is missing
    debug: true,

    // Our translation keys are plain English strings that contain "." and ":"
    // (e.g. "Library: Pending"). Disable the separators so i18next treats the
    // whole string as one key instead of a namespace/nested-key path.
    keySeparator: false,
    nsSeparator: false,

    resources: {
      en: {
        translation: enTranslation,
      },
      sv: {
        translation: svTranslation,
      },
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false,
    },
  });

export default i18next;
